import useBookmark from './use-bookmark';

export default useBookmark;
